enum Instruction {
    FORWARD = 'FORWARD',
    LEFT = 'LEFT',
    RIGHT = 'RIGHT',
    UP = 'UP',
    DOWN = 'DOWN',
    TILT_LEFT = 'TILT_LEFT',
    TILT_RIGHT = 'TILT_RIGHT',
    COLOR_RED = 'RED',
    COLOR_ORANGE = 'ORANGE',
    COLOR_YELLOW = 'YELLOW',
    COLOR_GREEN = 'GREEN',
    COLOR_BLUE = 'BLUE',
    COLOR_PURPLE = 'PURPLE',
    COLOR_BLACK = 'BLACK',
    PUSH = 'PUSH',
    POP = 'POP',
}

export default Instruction;
